import { useMutation, useQueryClient } from '@tanstack/react-query';
import { deleteTicketPriority } from '../../api/TICKET/ticketMeta';
import { toast } from 'react-toastify';

export const useDeleteTicketPriority = () => {
    const queryClient = useQueryClient();

    return useMutation({
        mutationFn: deleteTicketPriority,
        onSuccess: () => {
            queryClient.invalidateQueries({ queryKey: ['ticket-priorities'] });
            toast.success('Priorité supprimée avec succès');
        },
        onError: (error) => {
            toast.error(error.message || 'Erreur lors de la suppression de la priorité');
        },
    });
};
